import React from 'react';
import './video-modal.styles.scss';
import Modal from '@/components/modal/modal.component';

const VideoModal = ({
  show,
  cancel,
  platform,
  videoId,
  title
}) => {

  function closeModalAndStopVideo() {
    const iframe = document.querySelector('.video-modal-container iframe');
    iframe.contentWindow.postMessage(
        '{"event":"command","func":"pauseVideo","args":""}', 
        '*'
    );
    cancel();
  }
  return (
    <div className='video-modal-container'>
      <Modal
        show={show}
        cancel={() => closeModalAndStopVideo()}
        closeButton={true}
        text={title || 'Watch this video!'}
        cls='wide' >
        <div className='video-container'>
          {
            platform === 'youtube' &&
            <iframe
              width="100%"
              height="auto"
              src={`https://www.youtube.com/embed/${videoId}?si=LdjQszmRlBgIXxrs&enablejsapi=1`}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen ></iframe>
          }
        </div>
      </Modal>
    </div>
  )
}

export default VideoModal